import React from "react";
import { formatDate } from "../../../utils/utils";

function PersonInformation({ personResult, savedData, currentId, onFootballManagerIdChange }) {
  const currentSavedData = savedData.find(data => data.id === currentId) || {};

  return (
    <div className="mb-4">
      <h2 className="text-xl font-bold mb-2">Person Information</h2>
      {personResult.photo ? (
              <img src={personResult.photo.urls["150x150"]} alt={personResult.fullName} className="w-20 h-20" />
            ) : (
              <p>No photo available</p>
            )}
      <img
        src={`https://sortitoutsi.b-cdn.net/uploads/face/${personResult.fm_id}.png`}
        alt={personResult.usualName}
        
      />
      <p><strong>Name:</strong> {personResult.usualName}</p>
      <p><strong>Match Name:</strong> {personResult.matchName}</p>
      <p><strong>Date of Birth:</strong> {formatDate(personResult.birthDate)}</p>
      <p><strong>Nationality:</strong> {personResult.mainNationality?.name}</p>
      <p><strong>Team:</strong> {personResult.club?.name}</p>
      <div className="mt-2">
        <label htmlFor="footballManagerId" className="block text-sm font-medium text-gray-700">
          Football Manager ID:
        </label>
        <input
          type="text"
          id="footballManagerId"
          name="footballManagerId"
          value={currentSavedData.footballManagerId || ""}
          onChange={onFootballManagerIdChange}
          className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-300 focus:ring focus:ring-indigo-200 focus:ring-opacity-50"
        />
      </div>
    </div>
  );
}

export default PersonInformation;
